import { useEffect } from 'react';
import gsap from 'src/utils/gsapSetup.ts';

type Params = {
  topBgPinSelector: string;
  backgroundImageSelector: string;
  scrollHeight: number;
};

export default function useTopBackgroundPin({
  topBgPinSelector,
  backgroundImageSelector,
  scrollHeight,
}: Params) {
  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: topBgPinSelector,
          start: 'top top',
          end: `+=${scrollHeight - 260}`,
          scrub: true,
          pin: true,
          pinSpacing: false,
          markers: false,
          invalidateOnRefresh: true,
        },
      });

      tl.fromTo(
        backgroundImageSelector,
        { opacity: 1 },
        {
          opacity: 0,
          ease: 'none',
        },
        0.9,
      );
    });

    return () => ctx.revert();
  }, [topBgPinSelector, backgroundImageSelector, scrollHeight]);
}
